import { authAttributeSerializer } from "@megaron/access-control";
import { HttpUri } from "@megaron/http-uri";
import { MegaraxUri } from "@megaron/megarax-uri";
import { Serializers, SerializerValue } from "@megaron/serializers";

import { AppId } from "./app";

export const signalLevels = ["info", "warning", "error"] as const;
export type SignalLevel = (typeof signalLevels)[number];

export const signalSerializer = Serializers.object({
  signalType: Serializers.string,
  instanceKey: Serializers.string,
  level: Serializers.stringOneOf(...signalLevels),
  app: Serializers.string,
  name: Serializers.string,
  uri: Serializers.first(MegaraxUri.serializer, HttpUri.serializer, Serializers.string).optional(),
  authorizedAttributes: authAttributeSerializer.array(),
  createdAt: Serializers.datetime,
});

export type Signal = SerializerValue<typeof signalSerializer>;

export type SignalTypeMeta<TSubjectDocType extends string = string> = {
  subjectDocType: TSubjectDocType;
  level: SignalLevel;
  app: AppId;
  actionLabel: string;
};
